import { AdvancedPagination, Card, CardRanking } from '@features/ui';
import { FC, useCallback } from 'react';
import { TRecentActivity } from '@src/types';
import { formatDateByMST } from '@lib/utils.ts';
import { useNavigate } from 'react-router-dom';
import { Pagination } from '@src/types/common';

type RecentActivityAdvancedProps = {
  data: TRecentActivity[];
  pagination: Pagination;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
};

export const RecentActivityAdvanced: FC<RecentActivityAdvancedProps> = ({
  data,
  pagination,
  onPageChange,
  onPageSizeChange,
}) => {
  const navigate = useNavigate();

  const getCardBg = (status: string) => {
    switch (status) {
      case 'primary':
        return '#4DA2FF80';
      case 'success':
        return '#155724';
      case 'danger':
        return '#721c24';
      default:
        return '#4DA2FF80';
    }
  };

  const hadleUserClick = useCallback(
    (id?: number) => {
      if (!id) return;
      navigate(`/admin/users/${id}`);
    },
    [navigate]
  );

  return (
    <Card className={'flex flex-col gap-y-5 items-end'}>
      <div className={'flex flex-col gap-y-2.5 w-full'}>
        {data.map((item) => {
          return (
            <CardRanking
              key={item.id}
              bgColor={getCardBg(item.status)}
              className={'px-4.5 py-3.5 flex flex-row justify-between'}
            >
              <div>
                <p className={'text-xs font-bold'}>{item.log_type}</p>
                <p className={'text-[11px]'}>
                  {formatDateByMST(item.created_at)}
                </p>
                <p className={'text-[11px] text-[#C13839] font-bold'}>
                  {item.log_detail}
                </p>
              </div>
              {item.user ? (
                <div>
                  <p className={'text-[11px]'}>{item.user?.username}</p>
                  <p className={'text-[11px] underline'}>{item.user?.email}</p>
                  <p
                    className={
                      'text-blue text-[11px] hover:underline cursor-pointer'
                    }
                    onClick={() => hadleUserClick(item.user?.id)}
                  >
                    {`MINT > ${item.user.username}`}
                  </p>
                </div>
              ) : null}
            </CardRanking>
          );
        })}
      </div>
      <AdvancedPagination
        currentPage={pagination.currentPage}
        pageSize={pagination.pageSize}
        totalItems={pagination.totalItems}
        totalPages={pagination.totalPages}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
      />
    </Card>
  );
};
